import { getRawVestaMinterSc } from 'helpers/mvx/loader';

export const rawVestaContract = getRawVestaMinterSc();

export * from './getFirstSnapshotEpoch';
